import { render, staticRenderFns } from "./blog-single.vue?vue&type=template&id=d56f7292&"
import script from "./blog-single.vue?vue&type=script&lang=js&"
export * from "./blog-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports